import { PropsWithChildren } from 'react';
import { ChakraFlex, ChakraText, DateFormat, Text } from '@equip.health/ui';
import { getRelativeDateString } from '../utils';
import { DateTime } from 'luxon';
import { getTimezoneAbbreviation } from '~/lib/util/timezone.util';

interface TimeSlotGroupProps extends PropsWithChildren {
  date: string;
  firstSlotStartTime?: string;
  id: string;
  isFirstGroup?: boolean;
  patientTimezone?: string;
}

const TimeSlotGroup = ({
  children,
  date,
  firstSlotStartTime,
  id,
  isFirstGroup = false,
  patientTimezone,
}: TimeSlotGroupProps) => {
  const timezoneAbbreviation = patientTimezone
    ? getTimezoneAbbreviation(patientTimezone, firstSlotStartTime || date)
    : '';

  return (
    <ChakraFlex direction="column" gap="12px">
      <ChakraFlex
        alignItems="center"
        gap="12px"
        id={`${id}__time-slot-group-${date}`}
        justifyContent="space-between"
      >
        <ChakraFlex alignItems="center" gap="12px">
          <Text variant="bodyMedium">
            {DateTime.fromISO(date).toFormat(DateFormat.weekdayMonthDateNoPad)}
            {timezoneAbbreviation && ` (${timezoneAbbreviation})`}
          </Text>
          <Text color="neutral.secondary">
            {getRelativeDateString(date, patientTimezone)}
          </Text>
        </ChakraFlex>
        {isFirstGroup && patientTimezone && (
          <ChakraText
            color="neutral.500"
            fontSize="11px"
            fontWeight={400}
            letterSpacing="-0.03em"
            lineHeight="140%"
            paddingRight="18px"
          >
            All times shown in patient's time zone
          </ChakraText>
        )}
      </ChakraFlex>
      <ChakraFlex flexWrap="wrap" gap="12px">
        {children}
      </ChakraFlex>
    </ChakraFlex>
  );
};

export default TimeSlotGroup;
